<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改出库单' : '新增出库单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="115px"
        ref="editOrderFormRef"
        :rules="getRules"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="出库类型" prop="commodityOutputOrderTypeEnum">
          <EnumSelect
            enumName="CommodityOutputOrderTypeEnum"
            :multiple="false"
            placeholder="请选择出库类型"
            v-model="headInfo.commodityOutputOrderTypeEnum"
            @change="changeTypeEnum"
          >
          </EnumSelect>
        </el-form-item>
        <div v-if="headInfo.commodityOutputOrderTypeEnum == 'SaleOrder'">
          <el-form-item label="客户" prop="customerSupplierId">
            <CustomerSelect
              :value="customer"
              @select="selectCustomer"
            ></CustomerSelect>
          </el-form-item>
          <el-row :gutter="10" v-if="headInfo.customerSupplierId">
            <el-col :span="6">
              <el-form-item label="联系人信息" prop="customerSupplierId">
                <el-input
                  v-model="headInfo.customerSupplierName"
                  placeholder="请输入联系人姓名"
                  :disabled="!orderConfig.editCustomer"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="10" prop="customerId">
                <el-input
                  v-model="headInfo.customerSupplierPhoneNumber"
                  placeholder="请输入联系方式"
                  :disabled="!orderConfig.editCustomer"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="10" prop="customerId">
                <el-input
                  v-model="headInfo.customerSupplierAddress"
                  placeholder="请输入联系地址"
                  :disabled="!orderConfig.editCustomer"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div v-else>
          <el-form-item label="供应商" prop="customerSupplierId">
            <SupplierSelect
              :value="supplier"
              @select="selectSupplier"
            ></SupplierSelect>
          </el-form-item>
        </div>

        <el-form-item label="关联单据" prop="relatedOrderHeadId">
          <el-input
            :value="getSelectLabel('RelatedOrder')"
            :placeholder="
              getSelectLabel('RelatedOrder') || '请选择需要出库的单据'
            "
            style="width: 400px"
            readonly
            suffix-icon="el-icon-arrow-right"
            @click.native="toSelectOrder"
          ></el-input>
        </el-form-item>

        <el-form-item label="所选商品" prop="totalOutputQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="totalOutputQuantity && totalOutputQuantity > 0"
            >
              {{ "共 " + totalOutputQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择商品</span>
            <!-- <span>，总零售价：</span>
            <FmAmount :amount="headInfo.commodityBuyingTotalAmount"></FmAmount> -->
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="toSelectOrderItem('exist')"
              >选择商品</el-button
            >
          </div>
        </el-form-item>
        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo + row.relatedOrderItemId;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            label="商品图片"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityImage
                :commodity="getCommodityOrderItem(scope.row).commoditySnapshot"
                :commoditySpec="
                  getCommodityOrderItem(scope.row).commoditySpecSnapshot
                "
              ></CommodityImage>
            </template>
          </el-table-column>
          <el-table-column
            prop="commoditySnapshot.name"
            label="商品信息"
            min-width="150"
            align="left"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="line-height: 1.3em">
                <span style="font-size: 1.1em">{{
                  getCommodityOrderItem(scope.row).commoditySnapshot.name
                }}</span
                ><br />
                {{
                  "规格：" +
                  getCommodityOrderItem(scope.row).commoditySpecSnapshot
                    .specName
                }}<br />
                {{
                  "分类：" +
                  getCommodityOrderItem(scope.row).commoditySnapshot
                    .commodityCategory.name
                }}<br />
                {{
                  "颜色：" +
                  getCommodityOrderItem(scope.row).commoditySnapshot.color
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="buyingPrice"
            label="零售价"
            width="100"
            align="center"
            header-align="center"
            v-if="headInfo.commodityOutputOrderTypeEnum == 'SaleOrder'"
          >
            <template slot-scope="scope">
              <fm-amount
                :amount="scope.row.relatedSaleOrderItem.buyingPrice"
              ></fm-amount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="出库数量"
            width="430"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-table
                :data="scope.row.orderWareHouseAddNewPojoList || []"
                stripe
                border
                style="width: 100%"
                :row-key="
                  (row) => {
                    return row.itemNo + row.wareHouseId;
                  }
                "
              >
                <el-table-column
                  prop="name"
                  label="仓库"
                  min-width="200"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="innerScope">
                    {{
                      innerScope.row.wareHouse
                        ? innerScope.row.wareHouse.name
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="数量"
                  min-width="200"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="innerScope">
                    <CommodityQuantityInputBox
                      :key="
                        'orderWareHouseItemQuantityInputNumber' +
                        innerScope.$index +
                        itemQuantityKey
                      "
                      v-model="innerScope.row.itemQuantity"
                      size="small"
                      :max="getRelatedOrderItem(scope.row).toBeOutputQuantity"
                      @change="
                        (e) => {
                          changeOrderWareHouseItemQuantity(
                            scope.$index,
                            innerScope.$index,
                            innerScope.row,
                            e
                          );
                        }
                      "
                    ></CommodityQuantityInputBox>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="合计数量"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.itemQuantity }}
              <!-- <el-input-number
                :key="
                  'itemQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                v-model="scope.row.itemQuantity"
                size="small"
                :precision="0"
                :min="0"
                :max="getRelatedOrderItem(scope.row).toBeOutputQuantity"
                :step="1"
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
              ></el-input-number> -->
            </template>
          </el-table-column>
          <el-table-column
            label="出库详情"
            width="200"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <div
                v-for="(item, index) in scope.row.orderWareHouseAddNewPojoList"
                :key="index"
              >
                <div>
                  {{
                    "仓库：" +
                    item.wareHouse.name +
                    "，数量：" +
                    item.itemQuantity +
                    " " +
                    getCommodityOrderItem(scope.row).commoditySnapshot.unit
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="distributionPrice"
            label="配送费"
            width="200"
            align="center"
            header-align="center"
            v-if="headInfo.commodityOutputOrderTypeEnum == 'SaleOrder'"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.distributionPrice"
                size="small"
                :precision="2"
                :min="0"
                :step="1"
                @change="changeItemAmount(scope.$index, scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>

        <div v-if="headInfo.commodityOutputOrderTypeEnum == 'SaleOrder'">
          <el-form-item label="总配送费">
            <div style="height: 32px" class="fm-flex">
              <FmAmount :amount="headInfo.totalDistributionPrice"></FmAmount>
            </div>
          </el-form-item>
          <el-form-item label="" prop="needDelivery" class="fm-mt-10">
            <span slot="label">
              <el-tooltip effect="dark" content="" placement="top-start">
                <div slot="content" style="line-height: 1.5em">
                  <div style="font-weight: bold">配送标识说明</div>
                  配送标识所选商品是否需要配送，选项会影响后续单据流程。<br />
                  若需要配送则需要选择配送员将商品配送出库，单据审批通过后即可选择配送员进行配送；<br />
                  无需配送则代表无需配送员配送商品
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
              配送标识
            </span>
            <div class="fm-flex">
              <el-switch
                v-model="headInfo.needDelivery"
                :active-color="$jsTool.getColor('success')"
                :inactive-color="$jsTool.getColor('warning')"
                @change="handleNeedDelivery"
              >
              </el-switch>
              <p
                v-fmtype="'success'"
                class="fm-ml-10"
                v-if="headInfo.needDelivery"
              >
                需要配送
              </p>
              <span v-fmtype="'warning'" class="fm-ml-10" v-else>无需配送</span>
            </div>
          </el-form-item>
        </div>

        <el-form-item
          label="纸质单据"
          class="fm-mt-10"
          prop="paperOrderSysFileIdList"
          key="paperOrderSysFileIdList"
        >
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in paperOrderImageList"
            :key="index"
          >
            <el-image
              :id="'paperImage' + index"
              :src="file.url"
              :preview-src-list="paperOrderImageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="paperOrderImagePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="paperOrderImageDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="
              $envConfig.VUE_APP_uploadCommodityOutputOrderPaperOrder + ''
            "
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="paperOrderImageList"
            :show-file-list="false"
            :on-change="paperOrderImageChange"
            :on-success="paperOrderImageSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="paperOrderImageList.length < 10"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>

        <div
          v-show="
            headInfo.commodityOutputOrderTypeEnum == 'SaleOrder' &&
            headInfo.needDelivery
          "
        >
          <el-form-item>
            <span slot="label">
              <el-tooltip effect="dark" content="" placement="top-start">
                <div slot="content" style="line-height: 1.5em">
                  <div style="font-weight: bold">货物摆放位置说明</div>
                  货物摆放位置为'卖场'时需要上传货物摆放位置图片
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
              货物摆放位置
            </span>
            <el-radio-group
              v-model="headInfo.placemenPlaceEnum"
              @input="validPlacemen"
            >
              <el-radio label="Warehouse">库房</el-radio>
              <el-radio label="Store">卖场</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="摆放位置图片"
            class="fm-mt-10"
            prop="placementSysFileIdList"
          >
            <div
              class="fm-rela fm-uploadDiv-100"
              v-for="(file, index) in placementImageList"
              :key="index"
            >
              <el-image
                :id="'placementImage' + index"
                :src="file.url"
                :preview-src-list="placementImageList.map((d) => d.url)"
                :initial-index="index"
                alt=""
              />
              <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
                <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
              </div>
              <div class="HandleIcon">
                <i
                  @click="placementImagePreview(index)"
                  alt="预览图片"
                  class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
                ></i>
                <i
                  alt="删除图片"
                  @click="placementImageDelete(index, file)"
                  class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
                ></i>
              </div>
            </div>
            <el-upload
              :action="
                $envConfig.VUE_APP_uploadCommodityOutputOrderPlacementImage + ''
              "
              :headers="{
                AuthorityToken: $storageUtil.getAuthorityToken(),
              }"
              :limit="10"
              multiple
              accept="image/*"
              :file-list="placementImageList"
              :show-file-list="false"
              :on-change="placementImageChange"
              :on-success="placementImageSuccess"
              :on-exceed="() => this.$message.warning('最多上传10张图片')"
              v-if="placementImageList.length < 10"
            >
              <div slot="default" class="fm-center fm-uploadDiv-100">
                <i class="el-icon-plus"></i>
              </div>
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="50"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入出库说明等备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>

    <SaleOrderSelectDialog
      :show="saleOrderSelectDialogShow"
      :customerId="customer.id"
      from="CommodityOutputOrder"
      :selectList="itemList"
      @close="saleOrderSelectDialogShow = false"
      @selectSaleOrder="selectSaleOrder"
      v-if="saleOrderSelectDialogShow"
    >
    </SaleOrderSelectDialog>

    <SaleOrderItemSelectDialog
      :show="saleOrderItemSelectDialogShow"
      from="CommodityOutputOrder"
      :customerId="customer.id"
      :saleOrderId="relatedSaleOrderHead.id"
      :selectList="itemList"
      @close="saleOrderItemSelectDialogShow = false"
      @selectSaleOrderItem="selectSaleOrderItem"
      v-if="saleOrderItemSelectDialogShow"
    >
    </SaleOrderItemSelectDialog>

    <PurchaseReturnOrderSelectDialog
      :show="purchaseReturnOrderSelectDialogShow"
      :supplierId="supplier.id"
      from="CommodityOutputOrder"
      :selectList="itemList"
      @close="purchaseReturnOrderSelectDialogShow = false"
      @selectPurchaseReturnOrder="selectPurchaseReturnOrder"
      v-if="purchaseReturnOrderSelectDialogShow"
    >
    </PurchaseReturnOrderSelectDialog>

    <PurchaseReturnOrderItemSelectDialog
      :show="purchaseReturnOrderItemSelectDialogShow"
      from="CommodityOutputOrder"
      :supplierId="supplier.id"
      :purchaseReturnOrderId="relatedPurchaseReturnOrderHead.id"
      :selectList="itemList"
      @close="purchaseReturnOrderItemSelectDialogShow = false"
      @selectPurchaseReturnOrderItem="selectPurchaseReturnOrderItem"
      v-if="purchaseReturnOrderItemSelectDialogShow"
    >
    </PurchaseReturnOrderItemSelectDialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCommodityOutputOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          Object.assign(this.$data, this.$options.data());
          this.$nextTick(() => {
            this.$refs.editOrderFormRef.clearValidate();
          });
          this.initOrderData();
          this.getOrderConfig();
          this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
          if (this.orderId) {
            setTimeout(async () => {
              await this.getOrderInfo();
              this.$nextTick(() => {
                this.$refs.editOrderFormRef.clearValidate();
              });
            }, 100);
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    totalOutputQuantity() {
      return Number(
        this.$jsTool.sumQuantity(this.itemList.map((d) => d.itemQuantity))
      );
    },
    placementImageRequired() {
      if (
        this.orderConfig.placementImageRequired == "All" ||
        this.orderConfig.placementImageRequired ==
          this.headInfo.placemenPlaceEnum ||
        this.orderConfig.placementImageRequired ==
          this.headInfo.placemenPlaceEnum
      ) {
        return true;
      }
      return false;
    },
    getRules() {
      let res = {
        orderDate: this.$ruleUtil.simple({
          fieldName: "单据日期",
          handleType: "选择",
          required: true,
        }),
        commodityOutputOrderTypeEnum: this.$ruleUtil.simple({
          fieldName: "出库类型",
          handleType: "选择",
          required: true,
        }),
        customerSupplierId: this.$ruleUtil.simple({
          fieldName: "客户/供应商",
          handleType: "选择",
          required: true,
        }),
        relatedOrderHeadId: this.$ruleUtil.simple({
          fieldName: "关联单据",
          handleType: "选择",
          required: true,
        }),
        totalOutputQuantity: this.$ruleUtil.quantity(
          "出库商品",
          this.quantityMinLimit
        ),
        paperOrderSysFileIdList: this.$ruleUtil.array(
          "纸质单据",
          "上传",
          this.orderConfig.paperOrderRequired ? 1 : 0,
          10
        ),
        remark: this.$ruleUtil.simple({
          fieldName: "备注",
          required: false,
          max: 200,
        }),
      };
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        res.customerSupplierName = this.$ruleUtil.simple({
          fieldName: "联系人姓名",
          required: true,
          max: 50,
        });
        res.customerSupplierPhoneNumber = this.$ruleUtil.simple({
          fieldName: "联系方式",
          required: true,
          max: 20,
        });
        res.customerSupplierAddress = this.$ruleUtil.simple({
          fieldName: "联系地址",
          required: true,
          max: 20,
        });
        res.distributionPrice = this.$ruleUtil.number({
          fieldName: "配送费",
          required: true,
          min: 0,
        });
        if (this.headInfo.needDelivery) {
          res.placementSysFileIdList = this.$ruleUtil.array(
            "货物摆放位置",
            "上传",
            this.placementImageRequired ? 1 : 0,
            10
          );
        }
      }
      return res;
    },
  },
  data() {
    return {
      orderConfig: {
        needApproval: true,
        editCustomer: false,
        paperOrderRequired: true,
        placementImageRequired: true,
        postBackImageRequired: true,
        notDelivery: false,
      },

      // 预选的单据信息
      preInfo: {
        saleOrderId: null,
        saleOrder: {},
        purchaseReturnOrderId: null,
        purchaseReturnOrder: {},
      },

      orderDatePickerShow: false,
      commodityOutputOrderTypeEnumPickerShow: false,

      editItemPopupShow: false,
      editItem: {},

      id: null,
      headInfo: {
        orderApprovalStatusEnum: {},
        commodityOutputOrderTypeEnum: "",
        orderDate: null,
        customerSupplierId: null,
        customerSupplierName: null,
        customerSupplierPhoneNumber: null,
        customerSupplierAddress: "",
        relatedOrderHeadId: null,
        totalOutputQuantity: 0,
        needDelivery: true,
        paperOrderSysFileIdList: [],
        placemenPlaceEnum: "Store",
        placementSysFileIdList: [],
        remark: "",
        totalDistributionPrice: "0.00",
      },
      itemList: [],
      customer: {},
      supplier: {},
      relatedSaleOrderHead: {},
      relatedPurchaseReturnOrderHead: {},
      deliveryUserList: [],
      paperOrderImageList: [],
      placementImageList: [],

      selectWareHousePopupIndex: -1,
      wareHouseList: [],

      saleOrderSelectDialogShow: false,
      saleOrderItemSelectDialogShow: false,
      purchaseReturnOrderSelectDialogShow: false,
      purchaseReturnOrderItemSelectDialogShow: false,

      itemQuantityKey: "null",

      quantityMinLimit: 0.001,
    };
  },

  methods: {
    validPlacemen() {
      if (this.headInfo.placemenPlaceEnum == "Warehouse") {
        this.$refs.editOrderFormRef.clearValidate("placementSysFileIdList");
      } else {
        this.$refs.editOrderFormRef.validateField("placementSysFileIdList");
      }
    },
    getRelatedOrderItem(item) {
      return this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder"
        ? item.relatedSaleOrderItem
        : item.relatedPurchaseReturnOrderItem;
    },
    getCommodityOrderItem(item) {
      return this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder"
        ? item.relatedSaleOrderItem
        : item.relatedPurchaseReturnOrderItem.relatedPurchaseOrderItem;
    },
    // 摆放位置图片有关
    placementImagePreview(index) {
      document.getElementById("placementImage" + index).click();
    },
    placementImageDelete(index, file) {
      this.placementImageList.splice(index, 1);
      this.initPlacementImageList();
    },
    placementImageChange(file, fileList) {
      if (file.status == "ready") {
        this.placementImageList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initPlacementImageList();
    },
    placementImageSuccess(res, file, fileList) {
      let index = this.placementImageList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.placementImageList.splice(index, 1, {
          ...this.placementImageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.placementImageList.splice(index, 1);
      }
      this.initPlacementImageList();
    },
    initPlacementImageList() {
      this.$nextTick(() => {
        this.headInfo.placementSysFileIdList = this.placementImageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField("placementSysFileIdList");
      });
    },

    // 纸质单据有关
    paperOrderImagePreview(index) {
      document.getElementById("paperImage" + index).click();
    },
    paperOrderImageDelete(index, file) {
      this.paperOrderImageList.splice(index, 1);
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageChange(file, fileList) {
      if (file.status == "ready") {
        this.paperOrderImageList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageSuccess(res, file, fileList) {
      let index = this.paperOrderImageList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.paperOrderImageList.splice(index, 1, {
          ...this.paperOrderImageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.paperOrderImageList.splice(index, 1);
      }
      this.initPaperOrderSysFileIdList();
    },
    initPaperOrderSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.paperOrderSysFileIdList = this.paperOrderImageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField("paperOrderSysFileIdList");
      });
    },

    // 配送费相关
    handleNeedDelivery(e) {
      this.headInfo.needDelivery = e;
    },
    // 获取已选择的文本
    getSelectLabel(type) {
      if (type == "DeliveryUser") {
        if (this.deliveryUserList && this.deliveryUserList.length > 0) {
          return this.deliveryUserList
            .map((item) => {
              return item.name;
            })
            .join("、");
        }
      } else if (type == "Customer") {
        if (this.customer && this.customer.name) {
          return this.customer.customerNo + " " + this.customer.name;
        }
      } else if (type == "Supplier") {
        if (this.supplier && this.supplier.name) {
          return this.supplier.name;
        }
      } else if (type == "RelatedOrder") {
        if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
          if (this.relatedSaleOrderHead && this.relatedSaleOrderHead.id) {
            return this.relatedSaleOrderHead.orderNo;
          }
        } else {
          if (
            this.relatedPurchaseReturnOrderHead &&
            this.relatedPurchaseReturnOrderHead.id
          ) {
            return this.relatedPurchaseReturnOrderHead.orderNo;
          }
        }
      }
      return null;
    },
    selectSaleOrderItem(itemList) {
      this.itemList = itemList;
      this.headInfo.totalOutputQuantity = Number(
        this.$jsTool.sumQuantity(itemList.map((d) => d.itemQuantity))
      );
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("totalOutputQuantity");
      });
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        this.headInfo.totalDistributionPrice = this.$jsTool.sum(
          itemList.map((d) => d.distributionPrice)
        );
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.validateField("distributionPrice");
        });
      }
    },
    selectPurchaseReturnOrderItem(itemList) {
      this.itemList = itemList;
      this.headInfo.totalOutputQuantity = Number(
        this.$jsTool.sumQuantity(itemList.map((d) => d.itemQuantity))
      );
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("totalOutputQuantity");
      });
    },
    initOrderData() {
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.headInfo.commodityOutputOrderTypeEnum = "SaleOrder";
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CommodityOutputOrder:NeedApproval",
        "Order:CommodityOutputOrder:EditCustomer",
        "Order:CommodityOutputOrder:PaperOrderRequired",
        "Order:CommodityOutputOrder:PlacementImageRequired",
        "Order:CommodityOutputOrder:PostBackImageRequired",
        "Order:CommodityOutputOrder:NotDelivery",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityOutputOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }
        let editCustomerIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityOutputOrder:EditCustomer"
        );
        if (
          editCustomerIndex > -1 &&
          res.data[editCustomerIndex].value == "true"
        ) {
          this.orderConfig.editCustomer = true;
        }
        let paperOrderRequiredIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityOutputOrder:PaperOrderRequired"
        );
        if (
          paperOrderRequiredIndex > -1 &&
          res.data[paperOrderRequiredIndex].value == "false"
        ) {
          this.orderConfig.paperOrderRequired = false;
        }
        let placementImageRequiredIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityOutputOrder:PlacementImageRequired"
        );
        if (
          placementImageRequiredIndex > -1 &&
          res.data[placementImageRequiredIndex].value
        ) {
          this.orderConfig.placementImageRequired =
            res.data[placementImageRequiredIndex].value;
        }
        let postBackImageRequireIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityOutputOrder:PostBackImageRequire"
        );
        if (
          postBackImageRequireIndex > -1 &&
          res.data[postBackImageRequireIndex].value == "false"
        ) {
          this.orderConfig.postBackImageRequired = false;
        }
        let notDelivery = res.data.findIndex(
          (d) => d.code == "Order:CommodityOutputOrder:NotDelivery"
        );
        if (notDelivery > -1 && res.data[notDelivery].value == "true") {
          this.orderConfig.notDelivery = true;
          this.headInfo.needDelivery = !this.orderConfig.notDelivery;
        }
      }
    },
    changeOrderWareHouseItemQuantity(
      index,
      subIndex,
      row,
      orderWareHouseValue
    ) {
      if (orderWareHouseValue < 0) {
        row.itemQuantity = 0;
      }
      if (orderWareHouseValue <= 0) {
        if (this.itemList[index].orderWareHouseAddNewPojoList.length != 1) {
          this.itemList[index].orderWareHouseAddNewPojoList.splice(subIndex, 1);
        }
      } else {
        this.itemList[index].orderWareHouseAddNewPojoList.splice(
          subIndex,
          1,
          row
        );
      }
      let itemQuantity = this.itemList[
        index
      ].orderWareHouseAddNewPojoList.reduce((sum, current) => {
        return sum + current.itemQuantity;
      }, 0);
      this.changeItemQuantity(index, this.itemList[index], itemQuantity);
    },
    changeItemQuantity(index, row, value) {
      let that = this;
      if (value < 0) {
        row.itemQuantity = 0;
      }
      if (value <= 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            this.itemList[index].orderWareHouseAddNewPojoList.splice(0, 1);
            that.itemList.splice(index, 1);
            this.itemQuantityKey = Math.random();
            if (that.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
              that.selectSaleOrderItem(that.itemList || []);
            } else {
              that.selectPurchaseReturnOrderItem(that.itemList || []);
            }
          })
          .catch(() => {
            this.itemList[index].orderWareHouseAddNewPojoList[0].itemQuantity =
              this.quantityMinLimit;
            row.itemQuantity = this.quantityMinLimit;
            // this.changeItemQuantity(index, row, 1);
            this.itemQuantityKey = Math.random();
          });
      } else {
        if (that.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
          let distributionPrice = that.$jsTool.multi(
            value,
            row.relatedSaleOrderItem.commoditySpecSnapshot.distributionPrice
          );
          row = {
            ...row,
            itemQuantity: value,
            distributionPrice: distributionPrice,
          };
          that.itemList.splice(index, 1, row);
          that.selectSaleOrderItem(that.itemList || []);
        } else {
          row = {
            ...row,
            itemQuantity: value,
          };
          that.itemList.splice(index, 1, row);
          that.selectPurchaseReturnOrderItem(that.itemList || []);
        }
      }
    },
    changeItemAmount(index, row) {
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        this.itemList.splice(index, 1, row);
        this.selectSaleOrderItem(this.itemList || []);
      }
    },
    // 单据日期
    confirmPicker(e, type) {
      if (type == "OrderDate") {
        this.headInfo.orderDate = e.value;
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.validateField("orderDate");
        });
      }
      this.closePicker(type);
    },
    closePicker(type) {
      if (type == "OrderDate") {
        this.orderDatePickerShow = false;
      }
    },

    showOrderTypeEnumPicker() {
      if (this.preInfo.saleOrderId || this.preInfo.purchaseReturnOrderId) {
        this.$message({
          message: "自动创建出库单时无法切换出库类型",
          type: "error",
        });
        return;
      }
      this.commodityOutputOrderTypeEnumPickerShow = true;
    },
    // 选择出库类型
    confirmEnumPicker(e, type) {
      if (this.preInfo.saleOrderId || this.preInfo.purchaseReturnOrderId) {
        this.$message({
          message: "自动创建出库单时无法切换出库类型",
          type: "error",
        });
        return;
      }
      if (type == "CommodityOutputOrderTypeEnum") {
        this.headInfo.commodityOutputOrderTypeEnum = e.value[0].Name;
        this.headInfo.customerSupplierId = null;
        this.headInfo.customerSupplierName = null;
        this.headInfo.customerSupplierPhoneNumber = null;
        this.headInfo.customerSupplierAddress = "";
        if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
          this.headInfo.needDelivery = !this.orderConfig.notDelivery;
        }
        this.customer = {};
        this.supplier = {};
        this.headInfo.relatedOrderHeadId = null;
        this.relatedSaleOrderHead = {};
        this.relatedPurchaseReturnOrderHead = {};
        this.itemList = [];
        if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
          this.selectSaleOrderItem(this.itemList || []);
        } else {
          this.selectPurchaseReturnOrderItem(this.itemList || []);
        }
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.validateField(
            "commodityOutputOrderTypeEnum"
          );
        });
      }
      this.closeEnumPicker(type);
    },
    closeEnumPicker(type) {
      if (type == "CommodityOutputOrderTypeEnum") {
        this.commodityOutputOrderTypeEnumPickerShow = false;
      }
    },
    selectCustomer(item) {
      this.headInfo.customerSupplierId = item.id;
      this.headInfo.customerSupplierName = item.name;
      this.headInfo.customerSupplierPhoneNumber = item.phoneNumber;
      this.headInfo.customerSupplierAddress = item.address;
      this.customer = item;
      // 清空已选销售单和商品
      this.headInfo.relatedOrderHeadId = null;
      this.relatedSaleOrderHead = {};
      this.relatedPurchaseReturnOrderHead = {};
      this.itemList = [];
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrderItem(this.itemList || []);
      } else {
        this.selectPurchaseReturnOrderItem(this.itemList || []);
      }
      this.$message({
        message: "已自动更新联系人信息",
        type: "success",
      });
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("customerSupplierId");
      });
      setTimeout(() => {
        this.toSelectOrder();
      }, 200);
    },
    selectSupplier(item) {
      this.headInfo.customerSupplierId = item.id;
      this.headInfo.customerSupplierName = "";
      this.headInfo.customerSupplierPhoneNumber = "";
      this.headInfo.customerSupplierAddress = "";
      this.supplier = item;
      // 清空已选销售单和商品
      this.headInfo.relatedOrderHeadId = null;
      this.relatedSaleOrderHead = {};
      this.relatedPurchaseReturnOrderHead = {};
      this.itemList = [];
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrderItem(this.itemList || []);
      } else {
        this.selectPurchaseReturnOrderItem(this.itemList || []);
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("customerSupplierId");
      });
      setTimeout(() => {
        this.toSelectOrder();
      }, 200);
    },
    // 选择单据
    toSelectOrder() {
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        if (!this.customer || !this.customer.id) {
          this.$message({
            message: "请先选择客户",
            type: "error",
          });
          return;
        }
        let that = this;
        this.saleOrderSelectDialogShow = true;
      } else {
        if (!this.supplier || !this.supplier.id) {
          this.$message({
            message: "请先选择供应商",
            type: "error",
          });
          return;
        }
        let that = this;
        this.purchaseReturnOrderSelectDialogShow = true;
      }
    },
    selectSaleOrder(order) {
      this.headInfo.relatedOrderHeadId = order.id;
      this.relatedSaleOrderHead = order;
      this.itemList = [];
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrderItem(this.itemList || []);
      } else {
        this.selectPurchaseReturnOrderItem(this.itemList || []);
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("relatedOrderHeadId");
      });
      setTimeout(() => {
        this.toSelectOrderItem();
      }, 200);
    },
    selectPurchaseReturnOrder(order) {
      this.headInfo.relatedOrderHeadId = order.id;
      this.relatedPurchaseReturnOrderHead = order;
      this.itemList = [];
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrderItem(this.itemList || []);
      } else {
        this.selectPurchaseReturnOrderItem(this.itemList || []);
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("relatedOrderHeadId");
      });
      setTimeout(() => {
        this.toSelectOrderItem();
      }, 200);
    },
    // 选择单据行项目
    async toSelectOrderItem(exist) {
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        if (!this.customer || !this.customer.id) {
          this.$message({
            message: "请先选择客户",
            type: "error",
          });
          return;
        }
        if (!this.relatedSaleOrderHead || !this.relatedSaleOrderHead.id) {
          this.$message({
            message: "请先选择销售单",
            type: "error",
          });
          return;
        }
        this.saleOrderSelectDialogShow = false;
        if (!exist) {
          let getOrderRes = await this.$api.saleOrder_findVoById(
            this.relatedSaleOrderHead.id,
            {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "加载中...",
              },
            }
          );
          if (getOrderRes && getOrderRes.success) {
            let saleOrderVo = getOrderRes.data;
            this.handleConstructItemInfo(saleOrderVo.itemList);
            return;
          }
        }
        this.saleOrderItemSelectDialogShow = true;
      } else {
        if (!this.supplier || !this.supplier.id) {
          this.$message({
            message: "请先选择供应商",
            type: "error",
          });
          return;
        }
        if (
          !this.relatedPurchaseReturnOrderHead ||
          !this.relatedPurchaseReturnOrderHead.id
        ) {
          this.$message({
            message: "请先选择采购退货单",
            type: "error",
          });
          return;
        }
        this.purchaseReturnOrderSelectDialogShow = false;
        if (!exist) {
          let getOrderRes = await this.$api.purchaseReturnOrder_findVoById(
            this.relatedPurchaseReturnOrderHead.id,
            {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "加载中...",
              },
            }
          );
          if (getOrderRes && getOrderRes.success) {
            let purchaseReturnOrderVo = getOrderRes.data;
            this.handleConstructItemInfo(purchaseReturnOrderVo.itemList);
            return;
          }
        }
        this.purchaseReturnOrderItemSelectDialogShow = true;
      }
    },
    async handleConstructItemInfo(itemList) {
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        // 销售单
        let commodityIdList = itemList.map((d) => d.commodityId);
        let findCommodityVoRes = await this.$api.commodity_findVoByIdIn(
          commodityIdList,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
              text: "加载中...",
            },
          }
        );
        let commodityVoList = [];
        if (findCommodityVoRes && findCommodityVoRes.success) {
          commodityVoList = findCommodityVoRes.data;
        }
        let res = [];
        for (let index in itemList) {
          let item = itemList[index];
          if (item.toBeOutputQuantity <= 0) {
            continue;
          }
          let commodityVo = commodityVoList.filter(
            (f) => f.commodity.id == item.commodityId
          )[0];
          item.commodity = commodityVo.commodity;
          item.commoditySpec = commodityVo.commoditySpecList.filter(
            (f) => f.id == item.commoditySpecId
          )[0];
          let constructItem = {
            itemNo: index + 1,
            relatedOrderItemId: item.id,
            relatedSaleOrderItem: item,
            relatedSaleOrderItemId: item.id,
            itemQuantity: item.toBeOutputQuantity,
            distributionPrice:
              item.commoditySpecSnapshot.distributionPrice || "0.00",
            commodityBuyingTotalAmount: this.$jsTool.multi(
              item.buyingPrice,
              item.toBeOutputQuantity
            ),
            orderWareHouseAddNewPojoList: [
              {
                itemNo: 1,
                wareHouse: null,
                wareHouseId: null,
                fictitiousQuantity: 0,
                availableQuantity: 0,
                itemQuantity: item.toBeOutputQuantity,
              },
            ],
          };
          let specWareHouse = item.commoditySpec.commoditySpecWareHouseList[0];
          constructItem.orderWareHouseAddNewPojoList = [
            {
              itemNo: 1,
              wareHouse: specWareHouse.wareHouse || null,
              wareHouseId: specWareHouse.wareHouseId || null,
              fictitiousQuantity: specWareHouse.fictitiousQuantity || 0,
              availableQuantity: specWareHouse.availableQuantity || 0,
              itemQuantity: item.toBeOutputQuantity,
            },
          ];
          res.push(constructItem);
        }
        this.selectSaleOrderItem(res);
      } else {
        // 采购退货单
        let commodityIdList = itemList.map(
          (d) => d.relatedPurchaseOrderItem.commodityId
        );
        let findCommodityVoRes = await this.$api.commodity_findVoByIdIn(
          commodityIdList,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
              text: "加载中...",
            },
          }
        );
        let commodityVoList = [];
        if (findCommodityVoRes && findCommodityVoRes.success) {
          commodityVoList = findCommodityVoRes.data;
        }
        let res = [];
        for (let index in itemList) {
          let item = itemList[index];
          if (item.toBeOutputQuantity <= 0) {
            continue;
          }
          let commodityVo = commodityVoList.filter(
            (f) => f.commodity.id == item.relatedPurchaseOrderItem.commodityId
          )[0];
          item.relatedPurchaseOrderItem = {
            ...item.relatedPurchaseOrderItem,
            commodity: commodityVo.commodity,
            commoditySpec: commodityVo.commoditySpecList.filter(
              (f) => f.id == item.relatedPurchaseOrderItem.commoditySpecId
            )[0],
          };
          let constructItem = {
            itemNo: index + 1,
            relatedOrderItemId: item.id,
            relatedPurchaseReturnOrderItem: item,
            relatedPurchaseReturnOrderItemId: item.id,
            itemQuantity: item.toBeOutputQuantity,
            orderWareHouseAddNewPojoList: [
              {
                itemNo: 1,
                wareHouse: null,
                wareHouseId: null,
                fictitiousQuantity: 0,
                availableQuantity: 0,
                itemQuantity: item.toBeOutputQuantity,
              },
            ],
          };
          let specWareHouse =
            item.relatedPurchaseOrderItem.commoditySpec
              .commoditySpecWareHouseList[0];
          constructItem.orderWareHouseAddNewPojoList = [
            {
              itemNo: 1,
              wareHouse: specWareHouse.wareHouse || null,
              wareHouseId: specWareHouse.wareHouseId || null,
              fictitiousQuantity: specWareHouse.fictitiousQuantity || 0,
              availableQuantity: specWareHouse.availableQuantity || 0,
              itemQuantity: item.toBeOutputQuantity,
            },
          ];
          res.push(constructItem);
        }
        this.selectPurchaseReturnOrderItem(res);
      }
    },
    async getOrderInfo(args) {
      let res = await this.$api.commodityOutputOrder_findVoById(this.orderId, {
        showLoading: true,
        loadingParam: {
          target: "#editDialog > *",
          lock: true,
        },
        ...args,
      });
      if (res && res.success) {
        this.headInfo = {
          ...res.data.head,
          commodityOutputOrderTypeEnum:
            res.data.head.commodityOutputOrderTypeEnum.Name,
          commodityDeliverStatusEnum:
            res.data.head.commodityDeliverStatusEnum.Name,
          remark: res.data.head.remark || "",
          paperOrderSysFileIdList: res.data.head.paperOrderImageList.map(
            (d) => d.sysFile.id
          ),
          placemenPlaceEnum: res.data.head.placemenPlaceEnum.Name,
          placementSysFileIdList: res.data.head.placementImageList.map(
            (d) => d.sysFile.id
          ),
        };
        // 获取商品信息
        let commodityIdList = res.data.itemList.map(
          (d) => this.getCommodityOrderItem(d).commodityId
        );
        let findCommodityVoRes = await this.$api.commodity_findVoByIdIn(
          commodityIdList,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
            },
          }
        );
        let commodityVoList = [];
        if (findCommodityVoRes && findCommodityVoRes.success) {
          commodityVoList = findCommodityVoRes.data;
        }
        this.itemList = res.data.itemList.map((d) => {
          let commodityVo = commodityVoList.filter(
            (f) => f.commodity.id == this.getCommodityOrderItem(d).commodityId
          )[0];
          let item = d;
          if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
            item.relatedSaleOrderItem = {
              ...item.relatedSaleOrderItem,
              commodity: commodityVo.commodity,
              commoditySpec: commodityVo.commoditySpecList.filter(
                (f) => f.id == item.relatedSaleOrderItem.commoditySpecId
              )[0],
            };
          } else {
            item.relatedPurchaseReturnOrderItem.relatedPurchaseOrderItem = {
              ...item.relatedPurchaseReturnOrderItem.relatedPurchaseOrderItem,
              commodity: commodityVo.commodity,
              commoditySpec: commodityVo.commoditySpecList.filter(
                (f) =>
                  f.id ==
                  item.relatedPurchaseReturnOrderItem.relatedPurchaseOrderItem
                    .commoditySpecId
              )[0],
            };
          }
          item.orderWareHouseAddNewPojoList = d.orderWareHouseList.map((f) => {
            let specWareHouse = this.getCommodityOrderItem(
              item
            ).commoditySpec.commoditySpecWareHouseList.filter(
              (g) => g.wareHouseId == f.wareHouseId
            );
            return {
              itemNo: f.itemNo,
              wareHouse: f.wareHouse,
              wareHouseId: f.wareHouseId,
              fictitiousQuantity: specWareHouse.fictitiousQuantity || 0,
              availableQuantity: specWareHouse.fictitiousQuantity || 0,
              itemQuantity: f.itemQuantity,
            };
          });
          return item;
        });
        this.customer = res.data.head.customer;
        this.supplier = res.data.head.supplier;
        this.relatedSaleOrderHead = res.data.head.relatedSaleOrderHead;
        this.relatedPurchaseReturnOrderHead =
          res.data.head.relatedPurchaseReturnOrderHead;
        this.paperOrderImageList = res.data.head.paperOrderImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );
        this.placementImageList = res.data.head.placementImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );
        if (this.headInfo.orderParam) {
          let orderParam = JSON.parse(this.headInfo.orderParam);
          this.preInfo.saleOrderId = orderParam.preInfo.saleOrderId;
          this.preInfo.purchaseReturnOrderId =
            orderParam.preInfo.purchaseReturnOrderId;
        }
      }
    },
    edit(submit) {
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.commodityOutputOrder_updateAndSubmit(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.commodityOutputOrder_update(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.commodityOutputOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.commodityOutputOrder_saveIntoDraft(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },
    // 选择出库类型
    changeTypeEnum() {
      // this.headInfo.commodityOutputOrderTypeEnum = e.value[0].Name;
      this.headInfo.customerSupplierId = null;
      this.headInfo.customerSupplierName = null;
      this.headInfo.customerSupplierPhoneNumber = null;
      this.headInfo.customerSupplierAddress = "";
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        this.headInfo.needDelivery = !this.orderConfig.notDelivery;
      }
      this.customer = {};
      this.supplier = {};
      this.headInfo.relatedOrderHeadId = null;
      this.relatedSaleOrderHead = {};
      this.relatedPurchaseReturnOrderHead = {};
      this.itemList = [];
      if (this.headInfo.commodityOutputOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrderItem(this.itemList || []);
      } else {
        this.selectPurchaseReturnOrderItem(this.itemList || []);
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField(
          "commodityOutputOrderTypeEnum"
        );
      });
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CommodityOutputOrderEditDialog.vue